import {
    Button, Dialog,
    DialogTitle,
    DialogContent, ListItem,
    ListItemButton,
    List,
    ListItemText
} from "@mui/material";
import { SwapHoriz as ChangeIcon } from '@mui/icons-material';
import { useEffect, useState } from "react";

const WordsChooserComboBox = ({ word, wordIndex, dictionary, chosenWordSetter }) => {

    const [open, setOpen] = useState(false);
    const [dict, setDict] = useState([]);

    // const nthItemRef = useRef(null); // Ref to the nth item
    
    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };
    
    const handleWordClick = (wordIndex, wordObj) => {
        chosenWordSetter(wordIndex, wordObj);
        handleClose();
    };
    
    const sortWords = (wordsList) => {
        return wordsList.sort((a, b) => (a.word > b.word ? 1 : ((b.word > a.word) ? -1 : 0)));
    };
    
    // // Function to scroll to the nth item
    // const scrollToNthItem = () => {
    //   nthItemRef.current?.scrollIntoView({ behavior: "smooth" });
    // };

    // useEffect(() => {
    //     console.log('calling scroll')
    //     if (open) {
    //         setTimeout(5000, () => scrollToNthItem())
    //     }
    // }, [open])
                
    useEffect(() => {
        if (!dictionary)
            return;

        // console.log(dictionary)
        let arr = [];
        for (let v of dictionary.values()) {
            if (v) {
                let pointOfSpeech = '';
                try {
                    pointOfSpeech = v.pos
                } catch (error) {
                    console.log(error)
                }

                arr.push({ word: v.word, translation: v.translation, id: v.id, pos: pointOfSpeech });
            }
        }

        setDict([...sortWords(arr)]);
        // console.log(arr[0])
    }, [dictionary]);

    // const getCorrectRef = (wordObject) => {
    //     console.log(word.toLowerCase(), wordObject.word.toLowerCase() === word.toLowerCase())
    //     if (wordObject.word.toLowerCase() === word.toLowerCase()) {
    //         // console.log('yes', wordObject)
    //         return nthItemRef 
    //     } 
    //     // console.log('yes', wordObject)
    //     return null
    // }

    return (
        <>
            <Button variant="outlined" size="small" startIcon={<ChangeIcon />} onClick={handleClickOpen}>Change</Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Choose a word</DialogTitle>
                <DialogContent>
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: 512,
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: window.innerHeight * 0.7
                        }}
                    >
                        {dict && dict.map(wordObj => (
                            <ListItem 
                                key={`${wordObj.id}`} 
                            >
                                <ListItemButton
                                    // button
                                    key={`${wordObj.word} (${wordObj.pos})`}
                                    selected={wordObj.word.toLowerCase() === word.toLowerCase()}
                                    onClick={() => handleWordClick(wordIndex, wordObj)}
                                >
                                    <ListItemText primary={`${wordObj.word} (${wordObj.pos})`} secondary={wordObj.translation} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default WordsChooserComboBox